import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=48470d11&scoped=true"
import script from "./Images.vue?vue&type=script&lang=ts"
export * from "./Images.vue?vue&type=script&lang=ts"
import style0 from "./Images.vue?vue&type=style&index=0&id=48470d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48470d11",
  null
  
)

export default component.exports